<template>
  <div>
    <portal to="subPageHeader">
      <header-container slot-scope="props" :props="props">
        <slot></slot>

        <template #interactiveBlock>
          <slot name="interactiveBlock"></slot>
        </template>

        <template #controls>
          <slot name="controls"></slot>
        </template>

        <template #interactiveControls>
          <slot name="interactiveControls"></slot>
        </template>
      </header-container>
    </portal>

    <portal to="subPageHeader2">
      <header-container v-if="!screen.breakPoint.tabPort" slot-scope="props" :props="props">
        <slot></slot>

        <template #interactiveBlock>
          <slot name="interactiveBlock"></slot>
        </template>

        <template #controls>
          <slot name="controls"></slot>
        </template>

        <template #interactiveControls>
          <slot name="interactiveControls"></slot>
        </template>
      </header-container>
    </portal>
  </div>
</template>

<script>
import HeaderContainer from './Header'

import screen from '@/mixins/screen'

export default {
  mixins: [screen],

  components: {
    HeaderContainer
  }
}
</script>

<style lang="scss">
</style>
